// extracted by mini-css-extract-plugin
module.exports = {"iconRoot":"styles_iconRoot__2OdGt"};